module.exports = __webpack_public_path__ + "img/icon-logo.1749d3c0.png";